import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { stepReducer } from './reducers';
import { StepEffects } from './effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('step', stepReducer),
    EffectsModule.forFeature([StepEffects]),
  ],
  declarations: []
})
export class StepModule { }
